import { useEffect, useState } from 'react';
import axios from 'axios';
import SEO from '@/components/SEO';
import HeroSlider from '@/components/home/HeroSlider';
import AboutSection from '@/components/home/AboutSection';
import Milestones from '@/components/home/Milestones';
import ServicesGrid from '@/components/home/ServicesGrid';
import LocationsSection from '@/components/home/LocationsSection';
import SpacesSlider from '@/components/home/SpacesSlider';
import TestimonialsSlider from '@/components/home/TestimonialsSlider';
import BlogPreview from '@/components/home/BlogPreview';
import ContactSection from '@/components/home/ContactSection';
import AboutBuloke from '@/components/home/AboutBuloke';
import MapSection from '@/components/home/MapSection';
import GalleryCarousel from '@/components/home/GalleryCarousel';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Home() {
  const [sectionVisibility, setSectionVisibility] = useState({});

  useEffect(() => {
    // Fetch section visibility
    const fetchVisibility = async () => {
      try {
        const response = await axios.get(`${API}/sections/visibility`);
        const visibilityMap = {};
        response.data.forEach(section => {
          visibilityMap[section.section_name] = section.is_visible;
        });
        setSectionVisibility(visibilityMap);
      } catch (error) {
        console.error('Error fetching section visibility:', error);
        // Default all to visible on error
        setSectionVisibility({
          hero: true,
          about: true,
          milestones: true,
          services: true,
          locations: true,
          spaces: true,
          testimonials: true,
          blog: true,
          contact: true,
          map: true,
        });
      }
    };
    fetchVisibility();

    // Scroll reveal animation
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, observerOptions);

    const elements = document.querySelectorAll('.scroll-reveal');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div data-testid="home-page">
      <SEO page="home" />
      {sectionVisibility.hero !== false && <HeroSlider />}
      {sectionVisibility.about !== false && <AboutSection />}
      {sectionVisibility.milestones !== false && <Milestones />}
      {sectionVisibility.services !== false && <ServicesGrid />}
      {sectionVisibility.locations !== false && <LocationsSection />}
      {sectionVisibility.spaces !== false && <SpacesSlider />}
      {sectionVisibility.testimonials !== false && <TestimonialsSlider />}
      {sectionVisibility.blog !== false && <BlogPreview />}
      {sectionVisibility.gallery_carousel !== false && <GalleryCarousel />}
      {sectionVisibility.contact !== false && <ContactSection />}
      <AboutBuloke />
      {sectionVisibility.map !== false && <MapSection />}
    </div>
  );
}